(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('createUserAccount', {
                parent: 'app',
                url: '/createUserAccount?referralCode',
                data: {
                    authorities: [],
                    pageTitle: 'register.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/createUserAccount/create-user-account.html',
                        controller: 'CreateUserAccountController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('register');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                }
            })
            .state('activeUserAccount', {
                parent: 'app',
                url: '/activeUserAccount/{userName}',
                data: {
                    authorities: [],
                    pageTitle: 'register.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/createUserAccount/activate-user.html',
                        controller: 'ActiveUserController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('register');
                        $translatePartialLoader.addPart('personInfo');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'UserCustom', function ($stateParams, UserCustom) {

                        return ($stateParams.userName);
                    }]
                }
            })
            .state('resetPasswordByPhoneNumber', {
                parent: 'app',
                url: '/resetPasswordByPhoneNumber',
                data: {
                    authorities: [],
                    pageTitle: 'register.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/createUserAccount/reset-password-with-sms.html',
                        controller: 'ResetPasswordWithSMSController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('register');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('password');

                        return $translate.refresh();
                    }]
                }
            })

        ;
    }
})();
